import type { JSX } from 'react';

export function LoadingSkeleton(): JSX.Element {
	return (
		<div
			data-testid="media-hits-loading"
			className="animation-duration-[500ms] my-4 h-[150px] w-full animate-pulse rounded-md bg-gray-100"
		/>
	);
}
